// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['ast_ES']  = {
  "name": "ast_ES",
  "day": {
    "abbrev": [
      "dom",
      "llu",
      "mar",
      "mié",
      "xue",
      "vie",
      "sáb"
    ],
    "full": [
      "domingu",
      "llunes",
      "martes",
      "miércoles",
      "xueves",
      "vienres",
      "sábadu"
    ]
  },
  "month": {
    "abbrev": [
      "xin",
      "feb",
      "mar",
      "abr",
      "may",
      "xun",
      "xnt",
      "ago",
      "set",
      "och",
      "pay",
      "avi"
    ],
    "full": [
      "xineru",
      "febreru",
      "marzu",
      "abril",
      "mayu",
      "xunu",
      "xunetu",
      "agostu",
      "setiembre",
      "ochobre",
      "payares",
      "avientu"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d/%m/%y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

